var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-base',{class:_vm.componentClasses,attrs:{"borderRadius":'lg1',"type":'solid'},on:{"click":function($event){return _vm.clicked()}}},[_c('icon-cart'),_c('text-body-regular',{attrs:{"line-height":'multi',"weight":'extra-bold'}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }